import Buttons from './Buttons';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';

export const styles = theme => ({
    data: {
        marginTop: theme.spacing(),
        backgroundColor: theme.palette.background.paper,
        overflowY: 'auto',
        maxHeight: '300px',
        color: 'inherit',
    },
    subtitle1: {
        paddingTop: theme.spacing(),
    },
    warning: {
        paddingTop: theme.spacing(),
        color: 'inherit',
        fontWeight: 500,
    },

    link: {
        display: 'block',
        paddingTop: theme.spacing(),
        paddingBottom: theme.spacing(),
    },
    dense: {
        padding: 0,
    },
    textDense: {
        fontSize: '14px',
    },
    confirmation: {
        paddingTop: '10px',
    },
    textField: {
        margin: theme.spacing(),
    },

    labelControl: {
        marginLeft: 0,
    },
    label: {
        fontSize: '14px',
        fontWeight: 500,
    },
});

const renderComponents = (component, classeName) => {
    if (!component) {
        return;
    }
    if (React.isValidElement(component)) {
        return (
            <Typography
                component="div"
                variant="subtitle1"
                color="textSecondary"
                className={classeName}
            >
                {component}
            </Typography>
        );
    }
    return (
        <DialogContentText className={classeName}>
            {component}
        </DialogContentText>
    );
};

const ConfirmationDialog = props => {
    const [text, setText] = useState('');

    const {
        classes,
        open,
        onCancel,
        onOk,
        title,
        subtitle1,
        subtitle2,
        warning,
        confirmByTyping = null,
        link = null,
        data,
        cancelButtonName = 'Cancel',
        okButtonName = 'Ok',
        showCancelButton = true,
        loading = false,
    } = props;

    const canOk = confirmByTyping
        ? text.toLocaleLowerCase() === confirmByTyping.toLocaleLowerCase()
        : true;

    return (
        <Dialog open={open} onClose={onCancel} fullWidth={true} maxWidth="sm">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {renderComponents(subtitle1, classes.subtitle1)}
                {link && (
                    <a
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.link}
                    >
                        {link.name}
                    </a>
                )}
                {renderComponents(subtitle2, classes.subtitle1)}
                {renderComponents(warning, classes.warning)}
                <div className={classes.data}>
                    <List dense={true}>
                        {data &&
                            data.map((item, index) => (
                                <ListItem key={index} className={classes.dense}>
                                    <ListItemText
                                        className={classes.textDense}
                                        primary={item}
                                    />
                                </ListItem>
                            ))}
                    </List>
                </div>
                {confirmByTyping && (
                    <div className={classes.confirmation}>
                        <FormControl component="fieldset">
                            <FormControlLabel
                                className={classes.labelControl}
                                classes={{
                                    label: classes.label,
                                }}
                                control={
                                    <TextField
                                        className={classes.textField}
                                        value={text}
                                        onChange={event =>
                                            setText(event.target.value)
                                        }
                                        margin="dense"
                                        variant="outlined"
                                    />
                                }
                                label={`Type ${confirmByTyping.toUpperCase()} to confirm`}
                                labelPlacement="start"
                            />
                        </FormControl>
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Buttons>
                    {showCancelButton && (
                        <Buttons.Secondary
                            onClick={onCancel}
                            label={cancelButtonName}
                        />
                    )}
                    <Buttons.Primary
                        onClick={onOk}
                        autoFocus
                        variant="contained"
                        disabled={!canOk}
                        label={okButtonName}
                        loading={loading}
                    />
                </Buttons>
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles)(ConfirmationDialog);
